



















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import InputField from '@/components/common/inputs/InputField.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import TextArea from '@/components/common/inputs/TextArea.vue';
import Phases from '@/components/common/inputs/Phases.vue';
import Well from '@/components/common/Well.vue';
import WellItem from '@/components/common/WellItem.vue';
import FormSection from '@/components/details/FormSection.vue';
import WarningIcon from '@/components/icons/WarningIcon.vue';
import { StatusKeys, StatusLabels } from '@/models/status';
import { VisibilityKeys, VisibilityLabels } from '@/models/visibility';
import { Kle, Form, UserSearchRequest, OrgUnit } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import { Phase, PhaseKeys } from '@/models/phase';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import MunicipalityLogo from '@/components/common/MunicipalityLogo.vue';
import StarIcon from '@/components/icons/StarIcon.vue';
import AppDialog from '@/components/common/Dialog.vue';
import DialogContent from '@/components/common/DialogContent.vue';
import Button from '@/components/common/inputs/Button.vue';
import { AuthModule, User } from '@/store/modules/auth';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import { ErrorModule } from '@/store/modules/error';
import DatePicker from '@/components/common/inputs/DatePicker.vue';
import { OrganisationModule } from '@/store/modules/organisation';
import RichTextArea from '@/components/common/inputs/RichTextArea.vue';
import AttachmentUpload from '@/components/common/inputs/AttachmentUpload.vue';
import TagSelectorTechnologies from '@/components/common/inputs/TagSelectorTechnologies.vue';
import TagSelectorITSystems from '@/components/common/inputs/TagSelectorITSystems.vue';

@Component({
  components: {
    TagSelectorTechnologies,
    TagSelectorITSystems,
    InputField,
    SelectionField,
    InfoTooltip,
    StarIcon,
    TextArea,
    MunicipalityLogo,
    Phases,
    Well,
    FormSection,
    WellItem,
    WarningIcon,
    AppDialog,
    DialogContent,
    Button,
    DatePicker,
    RichTextArea,
    AttachmentUpload
  }
})
export default class GeneralInformationForm extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;
  isPhaseChanged = false;
  publicVisibilityDialogOpen = false;
  StatusKeys = StatusKeys;
  PhaseKeys = PhaseKeys;

  visibilityLevels = [
    { value: VisibilityKeys.PERSONAL, text: VisibilityLabels.PERSONAL },
    { value: VisibilityKeys.MUNICIPALITY, text: VisibilityLabels.MUNICIPALITY },
    { value: VisibilityKeys.PUBLIC, text: VisibilityLabels.PUBLIC }
  ];

  statusLevels = [
    { value: StatusKeys.REJECTED, text: StatusLabels.REJECTED },
    { value: StatusKeys.FAILED, text: StatusLabels.FAILED },
    { value: StatusKeys.PENDING, text: StatusLabels.PENDING },
    { value: StatusKeys.INPROGRESS, text: StatusLabels.INPROGRESS },
    { value: StatusKeys.NOT_RATED, text: StatusLabels.NOT_RATED },
    { value: StatusKeys.NOT_RELEVANT, text: StatusLabels.NOT_RELEVANT }
  ];

  get isWithinMunicipality() {
    return AuthModule.user?.cvr === ProcessModule?.cvr;
  }

  get logo() {
    if (this.state.base64Logo != null) {
      return this.state.base64Logo;
    } else {
      return `/logos/${ProcessModule?.cvr}.png`;
    }
  }

  get state() {
    return ProcessModule;
  }

  get common() {
    return CommonModule;
  }

  get technologies() {
    return CommonModule.technologies;
  }

  get itSystems() {
    return CommonModule.itSystems;
  }

  get canEditOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return true;
      }
      return false;
    } else {
      return ProcessModule.canEditOtherContact;
    }
  }

  get calculatedOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return ProcessModule.otherContactEmail;
      } else {
        return OrganisationModule.autoOtherContactEmail;
      }
    } else {
      return ProcessModule.otherContactEmail;
    }
  }

  get readonlyLinks() {
    // This function parses links and makes them clickable when the user is not editing.
    // First, it uses a long regex that matches urls (from http://urlregex.com) to match all urls in the text. Then it wraps them with an 'a' html tag.
    const firstPass = !ProcessModule.disabled?.attachmentsEdit
      ? ''
      : ProcessModule.codeRepositoryUrl?.replace(
          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/g,
          '<a href="$1" target="_blank">$1</a>'
        );
    // After wrapping the links with an 'a' tag, all matched links that start with 'www' but lack a protocol get an http protocol prepended in the href attribute.
    // Finally, the result is returned.
    return firstPass?.replace(/href="www/g, 'href="http://www');
    // TODO: Fix mails without schema and maybe other edge cases
  }

  assign(state: Partial<ProcessState>) {
    ProcessModule.assign(state);
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.generalInformation, name);
  }

  phaseChanged(phase: any) {
    this.isPhaseChanged = true;
    ProcessModule.update({ phase });

    if (
      (phase === PhaseKeys.OPERATION || phase === PhaseKeys.DECOMMISSIONED) &&
      ProcessModule.visibility !== VisibilityKeys.PUBLIC
    ) {
      this.openPublicVisibilityDialog();
    }
  }

  search(name: string) {
    const request: UserSearchRequest = { name: `${name}`, cvr: '' };
    if (AuthModule.user) {
      request.cvr = AuthModule.user.cvr;
      CommonModule.searchUsers(request);
    } else {
      CommonModule.searchUsers(request);
    }
  }

  openPublicVisibilityDialog() {
    this.publicVisibilityDialogOpen = true;
  }

  closePublicVisibilityDialog() {
    this.publicVisibilityDialogOpen = false;
  }

  setPublicVisibilityAndCloseDialog() {
    ProcessModule.setVisibility(VisibilityKeys.PUBLIC);
    this.closePublicVisibilityDialog();
  }

  setBookmark(bookmarked: boolean) {
    ProcessModule.setBookmark(bookmarked);
  }
}
